<template>
    <v-dialog-old ref="dialog" id="consultCancel">
        <form>
            <fieldset width="650">
                <legend>Причина отклонения вопроса</legend>
                <form>
                    <label>
                        <input type="radio" v-model="unpublishReasonDefault" value="Вопрос необходимо конкретизировать">
                        <span>Вопрос необходимо конкретизировать</span>
                    </label>
                    <label>
                        <input type="radio" v-model="unpublishReasonDefault" value="Вопрос вне медицинской тематики">
                        <span>Вопрос вне медицинской тематики</span>
                    </label>
                    <label>
                        <input type="radio" v-model="unpublishReasonDefault" value="Вопрос не может быть адресован конкретному врачу или клинике">
                        <span>Вопрос не может быть адресован конкретному врачу или клинике</span>
                    </label>
                    <label>
                        <input type="radio" v-model="unpublishReasonDefault" value="Вопрос может быть решен только на очном приеме у врача">
                        <span>Вопрос может быть решен только на очном приеме у врача</span>
                    </label>
                    <label>
                        <input type="radio" v-model="unpublishReasonDefault" value="Вопрос должен быть полным и не должен требовать от врача поиска по истории">
                        <span>Вопрос должен быть полным и не должен требовать от врача поиска по истории</span>
                    </label>
                    <label>
                        <input type="radio" v-model="unpublishReasonDefault" value="Ссылки запрещены, приложите файлы к вопросу">
                        <span>Ссылки запрещены, приложите файлы к вопросу</span>
                    </label>
                    <label>
                        <input type="radio" v-model="unpublishReasonDefault" value="Врач не отвечает на вопросы о записи в клинику">
                        <span>Врач не отвечает на вопросы о записи в клинику</span>
                    </label>
                    <label>
                        <input type="radio" v-model="unpublishReasonDefault" value="Врач не отвечает на вопросы по стоимости услуг">
                        <span>Врач не отвечает на вопросы по стоимости услуг</span>
                    </label>
                    <label>
                        <input type="radio" v-model="unpublishReasonDefault" value="На вопрос нельзя дать однозначный ответ">
                        <span>На вопрос нельзя дать однозначный ответ</span>
                    </label>
                    <label>
                        <input type="radio" v-model="unpublishReasonDefault" value="В тексте отсутствует вопрос">
                        <span>В тексте отсутствует вопрос</span>
                    </label>
                    <label>
                        <input type="radio" v-model="unpublishReasonDefault" value="Врач не смог ответить на ваш вопрос">
                        <span>Врач не смог ответить на ваш вопрос</span>
                    </label>
                    <label>
                        <input type="radio" v-model="unpublishReasonDefault" value="Другое">
                        <span>Другая причина</span>
                    </label>
                    <textarea v-model="unpublishReason" :disabled="unpublishReasonDefault !== 'Другое'"/>
                </form>
            </fieldset>
            <footer>
                <button class="green" @click="onConfirmBtn" :disabled="!unpublishReasonDefault">
                    Отменить публикацию
                </button>
            </footer>
        </form>
    </v-dialog-old>
</template>

<script>
export default {
    data: function () {
        return {
            unpublishReasonDefault: '',
            unpublishReason: '',
        };
    },
    methods: {
        show () {
            this.unpublishReasonDefault = '';
            this.unpublishReason = '';
            this.$refs.dialog.show();
        },
        onConfirmBtn() {
            this.$emit('canceled', this.unpublishReasonDefault === 'Другое' ? this.unpublishReason : this.unpublishReasonDefault);
            this.$refs.dialog.hide();
        },
    }
}
</script>

<style>
dialog#consultCancel {
    width: fit-content;
}
</style>
